import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    encryptKey: '', // 加密key
    encryptRandom: '', // 加密随机串
    routeParams: {} // 路由路径传参数据
  },
  // getter为state的计算属性
  getters: {
    getEncryptKey: state => state.encryptKey,
    getEncryptRandom: state => state.encryptRandom,
    getRouteParams: state => state.routeParams
  },
  mutations: {
    setIsCity: (state, data) => (state.isCity = data),
    setEncryptKey: (state, data) => (state.encryptKey = data),
    setEncryptRandom: (state, data) => (state.encryptRandom = data),
    setRouteParams: (state, data) => (state.routeParams = data)
  },
  actions: {
    setIsCity(context, data) {
      context.commit("setIsCity", data);
    },
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js